/**
 * Display truth for OptiVehicle fact values (presentation only).
 *
 * NHTSA-decoded equipment is what the SOURCE REPORTS for the VIN — OptiBay has
 * not inspected the vehicle — so it reads "Reported equipped" / "Reported not
 * equipped". A person's assertion is explicit and reads plainly "Equipped" /
 * "Not equipped". NHTSA "Optional" keeps "Optional on this model — verify on
 * the vehicle". The source badge (NHTSA decoded / Shop entered) stays beside it.
 *
 * The distinction is safe to make from the value: decoded equipment only ever
 * carries NHTSA's lookup vocabulary (Standard | Optional | Not Available,
 * Yes | No), and a person can only record Equipped | Not equipped
 * (validateAssertion, server-side).
 *
 * Nothing here changes what is stored, equipmentState(), the ADAS count,
 * conflicts or authority. It lives in the frontend — not in the Edge-bundled
 * facts.ts — so deployed Edge code is unchanged.
 */
import { formatFactValue, specOf } from '../../../supabase/functions/_shared/vehicleProfile/facts';

export function displayFactValue(key: string, value: string | null | undefined): string {
  const spec = specOf(key);
  if (spec?.equipment && value) {
    const v = value.trim().toLowerCase();
    if (v === 'standard' || v === 'yes') return 'Reported equipped';
    if (v === 'not available' || v === 'no') return 'Reported not equipped';
  }
  // NHTSA "Not Applicable" (kept only where it is information, e.g. no pickup bed on a sedan)
  if (value && /^\s*not applicable\s*$/i.test(value)) return 'Not applicable to this vehicle';
  return formatFactValue(key, value);
}
